import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { StatementsBase } from './Statements'

import { carriersSelector } from 'reduxModules/selectors/GlobalSelectors'
import { bookingUsersSelector } from 'reduxModules/selectors/UserSelectors'
import { bookingActions } from 'reduxModules/actions/BookingActions'
import { userActions } from 'reduxModules/actions/UserActions'

const mapStateToProps = createStructuredSelector({
  carriers: carriersSelector,
  bookingUsers: bookingUsersSelector,
})

const mapDispatchToProps = {
  getCarriersBookings: bookingActions.getCarriersBookings,
  getUserBookings: bookingActions.getUserBookings,
  getUsers: userActions.getUsers,
}

export const Statements = connect(mapStateToProps, mapDispatchToProps)(StatementsBase)


// WEBPACK FOOTER //
// ./src/components/Statements/index.js